module.exports = __webpack_public_path__ + "img/ResumeTemp2.3bbf9cf4.png";